import React from 'react';
import '../styles/Button.css';

const Button = ({ text, onClick, type = "button", className = "" }) => {
  return (
    <div className="button-wrapper">
      <button 
        type={type} 
        className={`custom-btn ${className}`} 
        onClick={onClick}
      >
        {text}
      </button>
    </div>
  );
};

export default Button;